// Module's CSS
import './style.scss';

import { onReady } from '../../global/js/utilities'; 

// Invoke classes when the DOM is ready
onReady(() => {
	// To-do
});
